<script>
import DropDown from '../reUse/DropDown.vue';
import FiltriO from '../reUse/Filtri.vue';
import ObracunJadralnih from './ObracunJadralnih.vue';
import ObracunUltraLight from './ObracunUltraLight.vue';
import Notification from "../reUse/Notification.vue";
import { i18n } from '@/i18n'
import { config } from '@/config'
import sl from '@/Prevodi/Obracun-sl.json';
import en from '@/Prevodi/Obracun-en.json';
import it from '@/Prevodi/Obracun-it.json';
export default {
  components: {
    DropDown,
    FiltriO,
    ObracunJadralnih,
    ObracunUltraLight,
    Notification
  },
  props: {},
  emits: ['odjava'],
  data() {
    return {
      prevodi: false,
      datumO: new Date().toISOString().split('T')[0],
      datumD: new Date().toISOString().split('T')[0],
      pilotName: '',
      regLetala: '',
      fNaloga: '',
      fNamen: '',
      klubM: '',
      klubP: '',
      dPilot: false,
      dLetalo: false,
      dFiltri: false,
      dKlubM: false,
      dKlubP: false,
      dNamen: false,
      dNaloga: false,
      Letala: [],
      Piloti: [],
      Klubi: [],
      KlubiL: [],
      namen: [
        {id: 0, namen: 'Trenažni let'},
        {id: 1, namen: 'Kontrolni let'},
        {id: 2, namen: 'Osnovno šolanje'},
        {id: 3, namen: 'Šolanje za poob.'},
        {id: 4, namen: 'Tekmovalni let'},
        {id: 5, namen: 'Izpitni let'},
        {id: 6, namen: 'Preizkusni let'},
        {id: 7, namen: 'AK'},
        {id: 8, namen: 'Protipožarni let'},
      ],
      naloga: [
        {id: 0, naloga: 'Šolski krog'},
        {id: 1, naloga: 'Vleka'},
        {id: 2, naloga: 'Let v rajonu'},
        {id: 3, naloga: 'Prelet'},
        {id: 4, naloga: 'Ruta'},
      ],
      PodatkiObracun: [],
      izbranZapis: [],
      podatkiIzbris: {},
      AllFlightsTime: '00:00',
      prikaz: 'motorna',
      izracun: [],
      polja: ['REG', 'VZLET', 'PILOT', 'TRAJANJE', 'NALOGA'], //default prikazna polja
      odpriPolja: false,
      //NOTIFICATION
      ShowNoti: false,
      text: '',
      types: '',
      pot: config.baseUrl,
      sortAscending: true,
      sending: false,
      exporting: false,
      printing: false,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetLetala();
    this.GetPiloti();
    this.GetKlubi();
    this.GetPodatkiObracuna();
  },
  computed: {
    FiltriraniPodatki() {
      if (this.klubM !== '') {
        if (this.klubP !== '') {
          if (this.fNaloga !== '') {
            if (this.fNamen !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen);
                }
              }
            } else { // ni izbran namen
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga);
                }
              }
            }
          } else { //ni izbrana naloga
            if (this.fNamen !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.namen === this.fNamen && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.namen === this.fNamen && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.namen === this.fNamen && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.namen === this.fNamen);
                }
              }
            } else { // ni izbran namen
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.klub_pilot === this.klubP);
                }
              }
            }
          }
        } else { //ni izbran klub pilota
          if (this.fNaloga !== '') {
            if (this.fNamen !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen);
                }
              }
            } else { // ni izbran namen
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.naloga === this.fNaloga && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.naloga === this.fNaloga && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.naloga === this.fNaloga && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.naloga === this.fNaloga);
                }
              }
            }
          } else { //ni izbrana naloga
            if (this.fNamen !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.namen === this.fNamen && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.namen === this.fNamen && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.namen === this.fNamen && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.namen === this.fNamen);
                }
              }
            } else { // ni izbran namen
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_letala === this.klubM);
                }
              }
            }
          }
        }
      } else { // ni izbran klub letala
        if (this.klubP !== '') {
          if (this.fNaloga !== '') {
            if (this.fNamen !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.namen === this.fNamen);
                }
              }
            } else { // ni izbran namen
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.naloga === this.fNaloga);
                }
              }
            }
          } else { //ni izbrana naloga
            if (this.fNamen !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.namen === this.fNamen && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.namen === this.fNamen && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.namen === this.fNamen && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.namen === this.fNamen);
                }
              }
            } else { // ni izbran namen
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.klub_pilot === this.klubP);
                }
              }
            }
          }
        } else { //ni izbran klub pilota
          if (this.fNaloga !== '') {
            if (this.fNamen !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.naloga === this.fNaloga && podatki.namen === this.fNamen && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.naloga === this.fNaloga && podatki.namen === this.fNamen);
                }
              }
            } else { // ni izbran namen
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.naloga === this.fNaloga && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.naloga === this.fNaloga && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.naloga === this.fNaloga && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.naloga === this.fNaloga);
                }
              }
            }
          } else { //ni izbrana naloga
            if (this.fNamen !== '') {
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.namen === this.fNamen && podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.namen === this.fNamen && podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.namen === this.fNamen && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.namen === this.fNamen);
                }
              }
            } else { // ni izbran namen
              if (this.pilotName !== '') {
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.pilot === this.pilotName && podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun.filter(podatki => podatki.pilot === this.pilotName);
                }
              } else { //ni izbran pilot
                if (this.regLetala !== '') {
                  return this.PodatkiObracun.filter(podatki => podatki.registracija === this.regLetala);
                } else { //ni izbrano letalo
                  return this.PodatkiObracun;
                }
              }
            }
          }
        }
      }
      // if(this.pilotName !== '') {
      //     if(this.regLetala !== '') {
      //         return this.PodatkiObracun.filter(podatki => podatki.pilot == this.pilotName && podatki.registracija == this.regLetala);
      //     }
      //     return this.PodatkiObracun.filter(podatki => podatki.pilot == this.pilotName);
      // }
      // if(this.regLetala !== '') {
      //     return this.PodatkiObracun.filter(podatki => podatki.registracija == this.regLetala);
      // }
      // return this.PodatkiObracun;
    },
    FilterLetal() {
      if (this.prikaz === 'motorna') {
        return this.Letala.letala.filter(letalo => letalo.vrsta_letala === 'Motorno');
      } else {
        return this.Letala.letala.filter(letalo => letalo.vrsta_letala === 'Jadralno');
      }
    }
  },
  methods: {
    selectPilot(id) {
      let pilot = this.Piloti.piloti.find(p => p.id === id);
      if (pilot) {
        // this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.pilotName = pilot.sifra;
        this.dPilot = false;
      }
    },
    selectLetalo(id) {
      let letalo = this.Letala.letala.find(l => l.id === id);
      if (letalo) {
        this.regLetala = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
      }
    },
    selectKlubM(id) {
      let klub = this.KlubiL.find(klub => klub.id === id);
      if (klub) {
        this.klubM = klub.naziv;
        this.dKlubM = false;
      }
    },
    selectKlubP(id) {
      let klub = this.Klubi.find(klub => klub.id === id);
      if (klub) {
        this.klubP = klub.naziv;
        this.dKlubP = false;
      }
    },
    selectNamen(id) {
      let namen = this.namen.find(n => n.id === id);
      if (namen) {
        this.dNamen = false;
        this.fNamen = namen.namen;
      }
    },
    selectNaloga(id) {
      let naloga = this.naloga.find(na => na.id === id);
      if (naloga) {
        this.dNaloga = false;
        this.fNaloga = naloga.naloga;
      }
    },
    OpenPilot() {
      this.dPilot = !this.dPilot;
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    OpenFiltri() {
      this.dFiltri = !this.dFiltri;
    },
    OpenKlubM() {
      this.dKlubM = !this.dKlubM;
    },
    OpenKlubP() {
      this.dKlubP = !this.dKlubP;
    },
    OpenNaloga() {
      this.dNaloga = !this.dNaloga;
    },
    OpenNamen() {
      this.dNamen = !this.dNamen;
    },
    GetPodatkiObracuna() {
      let app = this;
      let podatki = new URLSearchParams();
      podatki.append("datumZ", this.datumO);
      podatki.append("datumK", this.datumD);
      axios
          .post("./api/log/motorno/izpis/", podatki)
          .then(function (response) {
            app.PodatkiObracun = response.data.podatki;
            // app.CalculateFlights();
            app.AllFlightsTime = response.data.s_cas_letenja;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            // alert("Zapis uspešno dodan!");
            app.Letala = response.data;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPiloti() {
      let app = this;
      axios
          .get("./api/sifranti/piloti/izpis/")
          .then(function (response) {
            app.Piloti.piloti = response.data.piloti.filter(pilot => pilot.datum_izbrisa == null);
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetKlubi() {
      axios.get('./api/sifranti/klubi/izpis', {withCredentials: true}).then((response) => {
        this.Klubi = response.data.klubi;
        this.KlubiL = [...response.data.klubi];
        this.KlubiL.push({
          'id': 'lastno',
          'sifra': 'Privat-lastno',
          'naziv': 'Privat-lastno',
          'naslov': '/',
          'posta': '/',
          'kraj': '/',
          'tel': '/',
          'email': '/'
        });
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri branju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    sestejCase() {
      let skupneMinute = 0;
      let skupneUre = 0;
      for (let i = 0; i < this.FiltriraniPodatki.length; i++) {
        // Pretvori oba časa v minute
        let [ure, minute] = this.FiltriraniPodatki[i].cas_letenja.split(':').map(Number);
        skupneMinute += minute;
        skupneUre += ure;
      }
      while (skupneMinute >= 60) {
        skupneMinute -= 60;
        skupneUre++;
      }
      // Formatiraj nazaj v HH:MM
      const ureStr = String(skupneUre).padStart(2, '0');
      const minuteStr = String(skupneMinute).padStart(2, '0');

      return `${ureStr}:${minuteStr}`;

      // TVOJA FUNKCIJA
      // // Pretvori oba časa v minute
      // const [ure1, minute1] = cas1.split(':').map(Number);
      // const [ure2, minute2] = cas2.split(':').map(Number);

      // let skupneMinute = minute1 + minute2;
      // let skupneUre = ure1 + ure2;

      // // Upoštevaj prenos minut v ure
      // skupneUre += Math.floor(skupneMinute / 60);
      // skupneMinute = skupneMinute % 60;

      // // Formatiraj nazaj v HH:MM
      // const ureStr = String(skupneUre).padStart(2, '0');
      // const minuteStr = String(skupneMinute).padStart(2, '0');

      // return `${ureStr}:${minuteStr}`;
    },
    SestejPristanke() {
      let pristanki = 0;
      for (let i = 0; i < this.FiltriraniPodatki.length; i++) {
        // Pretvori oba časa v minute
        pristanki += this.FiltriraniPodatki[i].st_pristankov;
      }
      return pristanki;
    },
    CalculateFlights() { // TEGA NE POTREBUJEMO VEČ - PUŠČAM SAMO ZA INFO
      let AllFlightsTime = '00:00';
      for (let i = 0; i < this.PodatkiObracun.length; i++) {

        this.AllFlightsTime = this.sestejCase(AllFlightsTime, this.PodatkiObracun[i].cas_letenja);
      }
    },
    OpenView(id) {
      this.izbranZapis = this.PodatkiObracun.filter(p => p.id === id);
      $(this.$refs.modalObracunMotZapisa).modal('show');
    },
    Details(id) {
      this.izbranoLetalo = this.letala.filter(letalo => letalo.id === id);
      $(this.$refs.modalObracunMotZapisa).modal('show');
    },
    DetailsOff() {
      $(this.$refs.modalObracunMotZapisa).modal('hide');
    },
    InvoiceDetails() {
      $(this.$refs.modalObracunCena).modal('show');
    },
    InvoiceDetailsOff() {
      $(this.$refs.modalObracunCena).modal('hide');
    },
    PotrdiIzbris(id) {
      this.podatkiIzbris = {
        id: id
      };
      this.text = 'Ali res želite pobrisati zapis?';
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    izbrisiZapis() {
      // BRISANJE
      let app = this;
      let izbris = new URLSearchParams();
      izbris.append("id_brisanja", this.podatkiIzbris.id);
      axios
          .post("./api/log/motorno/brisi/", izbris)
          .then(function (response) {
            app.GetPodatkiObracuna();
            app.DetailsOff();
            app.podatkiIzbris = {};
            // alert(text);
            app.text = "Zapis uspešno pobrisan";
            app.types = "Uspešno";
            app.ShowNoti = true;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    NatisniIzpise() {
      this.printing = true;
      let podatki = new URLSearchParams();
      podatki.append('zapisiM', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/pdf/', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
        this.printing = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.printing = false;
      });
    },
    NatisniIzpiseBlob() {
      this.printing = true;
      let podatki = new URLSearchParams();
      podatki.append('zapisiM', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/pdf/', podatki, {
        responseType: 'blob'
      }).then(response => {
        const blob = new Blob([response.data], {
          type: 'application/pdf'
        });

        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');

        // Po potrebi kasneje sprostiš URL
        setTimeout(() => URL.revokeObjectURL(url), 1000);
        this.printing = false;
      }).catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri pridobivanju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
            this.printing = false;
          });
    },
    IzvozCSV() {
      this.exporting = true;
      let podatki = new URLSearchParams();
      podatki.append('zapisiM', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/csv/', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
        this.exporting = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.exporting = false;
      });
    },
    SendToMail() {
      this.sending = true;
      let podatki = new URLSearchParams();
      podatki.append('zapisiM', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/pdf/', podatki, {withCredentials: true}).then((response) => {
        let podatkiMail = new URLSearchParams();
        podatkiMail.append('datoteka', response.data.datoteka);
        podatkiMail.append('zadeva', 'Izpisek motornih letov');
        axios.post('./api/log/mail/', podatkiMail, {withCredentials: true}).then((response) => {
          // alert(response.data.sporocilo);
          this.text = (response.data.sporocilo);
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.sending = false;
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri pošiljanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri pošiljanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
          this.sending = false;
        });
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.sending = false;
      });
    },
    ObracunajLet() {
      if (this.regLetala !== '' && this.klubP !== '' && this.klubM !== '') {
        let podatki = new URLSearchParams();
        podatki.append('registracija', this.regLetala)
        podatki.append('cas_letenja', this.sestejCase());
        podatki.append('pristanki', this.SestejPristanke());
        podatki.append('klub_pilota', this.klubP);
        podatki.append('klub_letala', this.klubM);
        axios.post('./api/obracuni/motorno/', podatki, {withCredentials: true}).then((response) => {
          this.izracun = response.data.izracun;
          this.InvoiceDetails();
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri pridobivanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      } else {
        // alert('Za obračun leta je potrebno izbrati registracijo letala in klub pilota!');
        this.text = ('Za obračun leta je potrebno izbrati registracijo letala in klub pilota!');
        this.types = "Uspešno";
        this.ShowNoti = true;
      }
    },
    ToogleSort() {
      this.sortAscending = !this.sortAscending;
      this.PodatkiObracun.reverse();
    },
    IzbranaPolja() {
      while (this.polja.length > 5) {
        this.polja.pop();
        this.text = ('Izberete lahko največ 5 polj hkrati!');
        this.types = "Napaka";
        this.ShowNoti = true;
      }
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{$t('main.nazaj')}}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 v-if="prikaz === 'jadralna'" class="page-title">{{$t('nav.jadralna')}}</h1>
          <h1 v-if="prikaz === 'motorna'" class="page-title">{{$t('nav.motorna')}}</h1>
          <h1 v-if="prikaz === 'ultralight'" class="page-title">{{$t('nav.ultralight')}}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'motorna'}" @click="prikaz = 'motorna'" data-umami-event="Obracun-motorna">
              <i class="fas fa-plane-departure"></i>
              <span>{{$t('main.titleMotorna')}}</span>
            </button>
            <button class="nav-tab" :class="{'active': prikaz === 'jadralna'}" @click="prikaz = 'jadralna'" data-umami-event="Obracun-jadralna">
              <i class="fas fa-paper-plane"></i>
              <span>{{$t('main.titleJadralna')}}</span>
            </button>
            <button class="nav-tab" :class="{'active': prikaz === 'ultralight'}" @click="prikaz = 'ultralight'" data-umami-event="Obracun-ultralight">
              <i class="fas fa-plane-departure"></i>
              <span>{{$t('main.titleUltralight')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <obracun-jadralnih  v-show="prikaz === 'jadralna'" />
  <obracun-ultra-light  v-show="prikaz === 'ultralight'" />
  <div v-show="prikaz === 'motorna' && prevodi" class="container p-2">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types"  @da="izbrisiZapis" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
    </Transition>
    <div class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6">{{$t('labels.datumOd')}}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datumO" required @change="GetPodatkiObracuna"/>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6" >{{$t('labels.datumDo')}}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datumD" required @change="GetPodatkiObracuna" />
      </div>
    </div>
    <div class="hr-with-text">Filtriranje podatkov</div>
    <!-- KLUB LETALA -->
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="pilotName">{{$t('labels.klubL')}} <button v-if="klubM !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="klubM = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenKlubM()" >
          <i v-show="!dKlubM" class="fas fa-chevron-right"></i>
          <i v-show="dKlubM" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5"  id="pilotName" @click.prevent="OpenKlubM">{{klubM}}</button>
        <transition name="fade">
          <drop-down @klub="selectKlubM" :data="KlubiL" type="klubi" class="drop-down-btn" v-if="dKlubM" />
        </transition>
      </div>
    </div>
    <!-- KLUB PILOTA -->
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="pilotName">{{$t('labels.klubP')}} <button v-if="klubP !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="klubP = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenKlubP()" >
          <i v-show="!dKlubP" class="fas fa-chevron-right"></i>
          <i v-show="dKlubP" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5"  id="pilotName" @click.prevent="OpenKlubP">{{klubP}}</button>
        <transition name="fade">
          <drop-down @klub="selectKlubP" :data="Klubi" type="klubi" class="drop-down-btn" v-if="dKlubP" />
        </transition>
      </div>
    </div>
    <!-- NAMEN -->
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="pilotName">{{$t('labels.namen')}} <button v-if="fNamen !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="fNamen = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenNamen()" >
          <i v-show="!dNamen" class="fas fa-chevron-right"></i>
          <i v-show="dNamen" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5"  id="pilotName" @click.prevent="OpenNamen">{{fNamen}}</button>
        <transition name="fade">
          <drop-down @namen="selectNamen" :data="namen" type="namen" class="drop-down-btn" v-if="dNamen" />
        </transition>
      </div>
    </div>
    <!-- NALOGA -->
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="pilotName">{{$t('labels.naloga')}} <button v-if="fNaloga !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="fNaloga = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenNaloga()" >
          <i v-show="!dNaloga" class="fas fa-chevron-right"></i>
          <i v-show="dNaloga" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5"  id="pilotName" @click.prevent="OpenNaloga">{{fNaloga}}</button>
        <transition name="fade">
          <drop-down @naloga="selectNaloga" :data="naloga" type="naloga" class="drop-down-btn" v-if="dNaloga" />
        </transition>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="pilotName">{{$t('labels.pilot')}} <button v-if="pilotName !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="pilotName = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenPilot()" >
          <i v-show="!dPilot" class="fas fa-chevron-right"></i>
          <i v-show="dPilot" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="pilotName" @click.prevent="OpenPilot">{{pilotName}}</button>
        <transition name="fade">
          <drop-down @pilot="selectPilot" :data="Piloti" type="piloti" class="drop-down-btn" v-if="dPilot" />
        </transition>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="regLetala">{{$t('labels.reg')}}<button v-if="regLetala !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="regLetala = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()" >
          <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
          <i v-show="dLetalo" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5"  id="regLetala" @click.prevent="OpenLetalo">{{regLetala}}</button>
        <transition name="fade">
          <drop-down @letalo="selectLetalo" :data="FilterLetal" type="letalo" class="drop-down-btn" v-if="dLetalo" />
        </transition>
      </div>
    </div>
    <!-- <div class="col-12">
        <div class="container">
            <label class="label-dropdown" for="chooseFilter">Dodatni filtri :</label>
            <div class="drop-down-icon text-black" @click.prevent="OpenFiltri">
                <i v-show="!dFiltri" class="fas fa-chevron-right"></i>
                <i v-show="dFiltri" class="fas fa-chevron-down"></i>
            </div>
            <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenFiltri"></button>
            <transition name="fade">
                <filtri-o class="drop-down-btn" v-if="dFiltri"/>
            </transition>
        </div>
    </div> -->
    <div class="col-12 p-2">
      <div class="">
        <h4 class="text-white">{{$t('data.title')}} <br/>
          <div class='row'>
            <div class='col-5'>
              <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.exporting" @click.prevent="IzvozCSV" data-umami-event="Obracun-Motorna-izpis-csv">{{$t('buttons.csv')}}<i class="fas fa-file-csv" :class="{'fa-spin': this.exporting}"></i></button>
            </div>
            <div class='col-4'>
              <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.printing" @click.prevent="NatisniIzpise" data-umami-event="Obracun-Motorna-izpis-tisk">{{$t('buttons.natisni')}} <i class="fas fa-print" :class="{'fa-spin': this.printing}"></i></button>
            </div>
            <div class='col-3'>
              <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.sending" @click.prevent="SendToMail" data-umami-event="Obracun-Motorna-izpis-email">{{$t('buttons.poslji')}} <i class="far fa-envelope" :class="{'fa-spin': this.sending}"></i></button>
            </div>
            <br/>
            <div class='col-1 mt-2'>
              <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0" @click.prevent="odpriPolja = !odpriPolja"><i class="fas fa-sort"></i></button>
            </div>
            <div class='col-1 mt-2'>
              <button class="btn btn-sm btn-outline-secondary" @click.prevent="ToogleSort()"><i v-if="sortAscending" class="fas fa-chevron-down"></i> <i v-if="!sortAscending" class="fas fa-chevron-up"></i></button>
            </div>
            <div class='col-12'>
              <select v-show="odpriPolja" class="form-select p-2 mt-2" v-model="polja" multiple @change="IzbranaPolja">
                <option value='REG'>{{$t('table.reg')}}</option>
                <option value='VZLET'>{{$t('table.vzlet')}}</option>
                <option value='PILOT'>{{$t('table.pilot')}}</option>
                <option value='TRAJANJE'>{{$t('table.trajanje')}}</option>
                <option value='NALOGA'>{{$t('table.naloga')}}</option>
                <option value='DATUM'>{{$t('table.datum')}}</option>
                <option value='PRISTANEK'>{{$t('table.pristanek')}}</option>
              </select>
            </div>
          </div>
        </h4>
        <!-- IZPIS LETOV -->
        <section class="flight-section-pregled mt-2">

          <div class="section-header">
            <div class="section-icon motor">
              <i class="fas fa-plane"></i>
            </div>
            <div class="d-flex col-10 justify-content-between">
              <div>
                <h2>{{ $t('table.titleM') }}</h2>
                <span>{{ FiltriraniPodatki.length }} zapisov</span>
              </div>
              <div >
                <h2 class="text-success"> {{ $t('data.title').toUpperCase() }}</h2>
                <span>{{$t('data.stPristankov')}} {{this.SestejPristanke()}}</span>
              </div>
              <div>
                <h2>{{ $t('data.casVZraku') }}</h2>
                <span> {{ this.sestejCase() }} </span>
              </div>
            </div>
          </div>

          <div class="flight-list">

            <div
                class="flight-item-pregled"
                v-for="(id, index) in FiltriraniPodatki"
                @click.prevent="OpenView(id.id)"
            >
              <div class="flight-task">
                <span class="label-flight">{{$t('table.datum')}}</span>
                <strong>{{ id.datum.substring(0,5) }}</strong>
              </div>

              <div class="flight-date" v-if="polja.includes('REG')">
                <i class="fas fa-plane"></i>
                <span>{{ id.registracija }}</span>
              </div>

              <div class="flight-user" v-if="polja.includes('VZLET')">
                <span class="label-flight">{{$t('table.vzlet')}} <i class="fas" :class="{'fa-sort-up' : sortAscending, 'fa-sort-down' : !sortAscending}"></i></span>
                <strong>{{ id.cas_vzleta }}</strong>
              </div>

              <div class="flight-task" v-if="polja.includes('PILOT')">
                <span class="label-flight">{{$t('table.pilot')}}</span>
                <strong>{{ id.pilot }}</strong>
              </div>

              <div class="flight-task" v-if="polja.includes('TRAJANJE')">
                <span class="label-flight">{{$t('table.trajanje')}}</span>
                <strong>{{ id.cas_letenja }}</strong>
              </div>

              <div class="flight-task" v-if="polja.includes('NALOGA')">
                <span class="label-flight">{{$t('table.naloga')}}</span>
                <strong>{{ id.naloga }}</strong>
              </div>

              <div class="flight-task" v-if="polja.includes('DATUM')">
                <span class="label-flight">{{$t('table.datum')}}</span>
                <strong>{{ id.datum.substring(0,5) }}</strong>
              </div>

              <div class="flight-task" v-if="polja.includes('PRISTANEK')">
                <span class="label-flight">{{$t('table.pristanek')}}</span>
                <strong>{{ id.cas_pristanka }}</strong>
              </div>

              <div class="flight-action">
                <i class="fas fa-chevron-right"></i>
              </div>

            </div>

            <div v-if="!FiltriraniPodatki.length" class="empty-state">
              <i class="far fa-folder-open"></i>
              <span>Ni podatkov</span>
            </div>

          </div>

        </section>
      </div>
      <!-- OBRAČUN LETA -->
      <!--                 <div class="col-12 p-2 d-flex justify-content-center">
                          <button class='btn btn-sm btn-outline-success' @click.prevent="ObracunajLet()"><i class="fas fa-calculator"></i> Obračunaj izpisane lete <i class="fas fa-receipt"></i></button>
                      </div> -->
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
    <div class='col-12 p-2'></div>
    <!-- OBRAČUN PODROBNO -->
    <div class="modal modal-kartica" ref="modalObracunMotZapisa" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange" v-if="izbranZapis.length > 0">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <div class='modal-header'>
            <h5 class="card-title"><i class="fas fa-plane"></i> Izbran zapis</h5>
          </div>
          <div class="modal-body col-12" style="overflow-y: scroll;">
            <ul class='list-group list-group-flush'>
              <li class='list-group-item list-dark'>{{$t('modal.reg')}} {{izbranZapis[0].registracija}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.vlecno')}}<i class="fas" :class="{'fa-times': !izbranZapis[0].vlecno, 'fa-check': izbranZapis[0].vlecno }"></i></li>
              <li class='list-group-item list-dark'>{{$t('modal.pilot')}} {{izbranZapis[0].pilot}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.instruktor')}} {{izbranZapis[0].instruktor}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.namen')}} {{izbranZapis[0].namen}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.naloga')}} {{izbranZapis[0].naloga}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.krajV')}} {{izbranZapis[0].kraj_vzleta}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.krajP')}} {{izbranZapis[0].kraj_pristanka}}</li>
              <!-- <li class='list-group-item list-dark'>čas vziga: {{izbranZapis[0].cas_vziga}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.casV')}}{{izbranZapis[0].cas_vzleta}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.casP')}} {{izbranZapis[0].cas_pristanka}}</li>
              <!-- <li class='list-group-item list-dark'>čas ugasanja: {{izbranZapis[0].cas_ugasanja}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.casL')}} {{izbranZapis[0].cas_letenja}}</li>
              <!-- <li class='list-group-item list-dark'>čas stanja: {{izbranZapis[0].cas_stanja}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.stPristankov')}} {{izbranZapis[0].st_pristankov}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.ifr')}}{{izbranZapis[0].ifr}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.nocno')}}{{izbranZapis[0].nocno}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.vizuelno')}} {{izbranZapis[0].vizuelno}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.opomba')}} {{izbranZapis[0].tip}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.datumL')}} {{izbranZapis[0].datum}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.datumV')}} {{izbranZapis[0].datum_vnosa}}</li>
            </ul>
          </div>
          <div class="modal-footer col-12"><button class="btn btn-outline-danger" @click.prevent="PotrdiIzbris(izbranZapis[0].id)">{{$t('buttons.brisiZapis')}}</button></div>
        </div>
      </div>
    </div>
    <!-- OBRAČUN CENE IZPIS -->
    <div class="modal modal-kartica" ref="modalObracunCena" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="InvoiceDetailsOff">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <div class='modal-header'>
            <h5 class="card-title"><i class="fas fa-plane"></i> Račun za {{this.regLetala}}</h5>
          </div>
          <div class="modal-body col-12" style="overflow-y: scroll;">
            <ul class='list-group list-group-flush'>
              <li class='list-group-item list-dark'>registracija: {{this.regLetala}}</li>
              <li class='list-group-item list-dark'>št. pristankov: {{this.izracun.st_pristankov}}</li>
              <li class='list-group-item list-dark'>cena: {{this.izracun.cena}}€/min</li>
              <li class='list-group-item list-dark'>skupni čas letenja: {{this.sestejCase()}}</li>
              <li class='list-group-item list-dark'>skupni čas letenja v minutah: {{this.izracun.cas_letenja_minute}}</li>
              <li class='list-group-item border-lorange'>Znesek za plačilo: {{this.izracun.izracun}}€</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>